module.exports = __webpack_public_path__ + "static/img/4-WAY STRETCHABLE PU products discription1_deskstop.8b29a65c.jpg";